import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Component({
	selector: 'ngx-label-wrapper',
	templateUrl: './label-wrapper.component.html'
})
export class LabelWrapperComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() public label = '';
	public isFocused = false;

	constructor (
		private elementRef: ElementRef,
		private renderer: Renderer2
	) {
	}

	public ngOnInit (): void {
		const element = this.elementRef.nativeElement;
		element.addEventListener('label-input:focus', this.focusHandler);
		element.addEventListener('label-input:blur', this.blurHandler);
	}

	public ngOnDestroy (): void {
		const element = this.elementRef.nativeElement;
		element.removeEventListener('label-input:focus', this.focusHandler);
		element.removeEventListener('label-input:blur', this.blurHandler);
	}

	public ngAfterViewInit (): void {
		const content = this.elementRef.nativeElement.querySelector('div.label-wrapper-content > *');
		if (content) {
			const displayStyle = window.getComputedStyle(content).getPropertyValue('display');
			this.renderer.setStyle(this.elementRef.nativeElement, 'display', displayStyle);
		}
	}

	private focusHandler = () => {
		this.isFocused = true;
	};

	private blurHandler = () => {
		this.isFocused = false;
	};
}
